export default {
  'pages.layouts.userLayout.title': 'ニュース放送学習',
  'pages.login.accountLogin.tab': 'アカウントログイン',
  'pages.login.accountLogin.errorMessage':
    'ユーザー名/パスワードが正しくありません',
  'pages.login.failure': 'ログインに失敗したら、もう一度試してください!',
  'pages.login.success': 'ログイン成功!',
  'pages.login.username.placeholder': 'ユーザー名：adminまたはuser',
  'pages.login.username.required': 'ユーザー名を入力してください！',
  'pages.login.password.placeholder': 'パスワード：ant.design',
  'pages.login.password.required': 'パスワードを入力してください！',
  'pages.login.phoneLogin.tab': '電話ログイン',
  'pages.login.phoneLogin.errorMessage': '検証コードエラー',
  'pages.login.phoneNumber.placeholder': '電話番号',
  'pages.login.phoneNumber.required': '電話番号を入力してください！',
  'pages.login.phoneNumber.invalid': '電話番号が無効です！',
  'pages.login.captcha.placeholder': '確認コード',
  'pages.login.captcha.required': '確認コードを入力してください！',
  'pages.login.phoneLogin.getVerificationCode': '確認コードを取得',
  'pages.getCaptchaSecondText': '秒',
  'pages.workbench.link': 'ようこそ',
  'pages.workbench.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',
  'pages.template.title': 'テンプレート',
  'pages.template.submit.success': 'フォームを送信しました！',
  'pages.template.form.name': '氏名',
  'pages.template.form.email': 'メール',
  'pages.template.form.department': '部署',
  'pages.template.form.joinDate': '入社日',
  'pages.template.form.remarks': '備考',
  'pages.template.placeholder.name': '氏名を入力してください',
  'pages.template.placeholder.email': 'メールを入力してください',
  'pages.template.placeholder.department': '部署を選択してください',
  'pages.template.placeholder.remarks': '備考を入力してください',
  'pages.template.validation.nameRequired': '氏名を入力してください',
  'pages.template.validation.emailRequired': 'メールを入力してください',
  'pages.template.validation.emailInvalid': 'メール形式が正しくありません',
  'pages.template.validation.departmentRequired': '部署を選択してください',
  'pages.template.validation.joinDateRequired': '入社日を選択してください',
  'pages.template.department.tech': '技術部',
  'pages.template.department.sales': '営業部',
  'pages.template.department.hr': '人事部',
  'pages.template.department.finance': '財務部',
  'pages.template.action.submit': '送信',
  'pages.template.action.reset': 'リセット',
  'pages.newsBroadcast.dashboard.title': '分析概要',
  'pages.newsBroadcast.dashboard.subtitle':
    'ニュース放送データの全体像とクイック操作',
  'pages.newsBroadcast.analysis.title': '毎日聯播インサイト',
  'pages.newsBroadcast.analysis.subtitle':
    '当日のニュース聯播が示す政策・産業・社会シグナルを把握する',
  'pages.newsBroadcast.analysisTasks.title': '分析タスクセンター',
  'pages.newsBroadcast.analysisTasks.subtitle':
    'タスク状態追跡・失敗再試行・スナップショット再構築',
  'pages.newsBroadcast.search.title': 'ニュース検索',
  'pages.newsBroadcast.search.subtitle': 'キーワードと条件でニュースを検索',
  'pages.newsBroadcast.keywordTrends.title': 'グローバル語彙トレンド',
  'pages.newsBroadcast.keywordTrends.subtitle':
    '期間を指定して語彙の熱度・活性度・推移を分析',
  'pages.newsBroadcast.dailyBrief.title': 'デイリーブリーフ',
  'pages.newsBroadcast.dailyBrief.subtitle': '対象別の日次ブリーフを生成・配信',
  'pages.newsBroadcast.dailyBriefDetail.title': 'ブリーフ詳細',
  'pages.newsBroadcast.dailyBriefDetail.subtitle':
    '全文、核心ポイント、隠れたシグナル、行動提案',
  'pages.newsBroadcast.shareBrief.title': 'デイリーブロードキャストブリーフ',
  'pages.newsBroadcast.shareBrief.notFound':
    'このブリーフは存在しないか、無効になっています',
  'pages.newsBroadcast.shareBrief.keyPoints': '核心ポイント',
  'pages.newsBroadcast.shareBrief.hiddenSignals': '隠れたシグナル',
  'pages.newsBroadcast.shareBrief.actionAdvice': '行動提案',
  'pages.newsBroadcast.shareBrief.readingTime': '読了目安 {minutes} 分',
  'pages.newsBroadcast.shareBrief.footer':
    'AI生成コンテンツ・提供元「{brand}」',
  'pages.newsBroadcast.dataManagement.title': 'データ管理',
  'pages.newsBroadcast.dataManagement.subtitle':
    '放送回とニュース明細データを管理',
  'pages.newsBroadcast.admin.title': '管理',
  'pages.newsBroadcast.admin.subtitle': '収集・分析・保守操作を実行',
  'pages.newsBroadcast.settings.title': '設定',
  'pages.newsBroadcast.settings.subtitle': '通知・分析・データソースを設定',
  'newsBroadcast.dataManagement.broadcastList': 'ニュース放送一覧',
  'newsBroadcast.dataManagement.newsDetail': 'ニュース詳細',
  'newsBroadcast.dataManagement.selectBroadcast':
    'ニュース放送を選択してください',
  'newsBroadcast.dataManagement.noNews': 'ニュースデータがありません',
  'newsBroadcast.dataManagement.newsCount': 'ニュース数',
  'newsBroadcast.dataManagement.lunarDate': '旧暦',
  'newsBroadcast.dataManagement.solarTerm': '現在の節気',
  'newsBroadcast.dataManagement.nextSolarTerm': '次の節気',
  'newsBroadcast.dataManagement.summary': '要約',
  'newsBroadcast.dataManagement.noSummary': '要約はありません',
  'newsBroadcast.dataManagement.readCount': '閲覧数',
  'newsBroadcast.dataManagement.shareCount': '共有数',
  'newsBroadcast.dataManagement.heatScore': 'ヒートスコア',
  'newsBroadcast.dataManagement.keywordAnalysis': 'キーワード分析',
  'newsBroadcast.dataManagement.contentAnalysis': '内容分析',
  'newsBroadcast.common.refresh': '更新',
  'newsBroadcast.common.noData': 'データなし',
  'newsBroadcast.common.error':
    '操作に失敗しました。後でもう一度お試しください',
  'newsBroadcast.common.published': '公開済み',
  'newsBroadcast.common.draft': '下書き',
  'newsBroadcast.common.archived': 'アーカイブ済み',
  'newsBroadcast.common.view': '表示',
  'newsBroadcast.common.share': '共有',
  'newsBroadcast.common.download': 'ダウンロード',
  'newsBroadcast.common.keyword': 'キーワード',
};
